import * as API from '../data/account_expense_api';
import {signOutAction} from "./auth_actions";
import {getInspectionDetailById} from "./inspection_action";

export const GET_EXPENSE_LIST = "get_expenses";
export const GET_EXPENSE_ESTIMATES_LIST = "get_expense_estimate_list";
export const CLEAR_DATA = "clear_loaded_data";
export const GET_EXPENSE_DETAIL = "get_expense_detail";
export const GET_EXPENSE_ESTIMATE_DETAIL = "get_expense_estimate_detail";

export function getExpenseList(startDate,endDate) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getExpenses(startDate,endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_EXPENSE_LIST,
                payload:response.data
            });
        }
    };
}

export function getExpenseEstimates() {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getExpenseEstimateList();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_EXPENSE_ESTIMATES_LIST,
                payload:response.data
            });
        }
    };
}


export function getExpenseDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getExpenseDetail(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_EXPENSE_DETAIL,
                payload:response.data.expense
            });
        }
    };
}

export function getEstimateDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getEstimateDetails(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_EXPENSE_ESTIMATE_DETAIL,
                payload:response.data['pipeline_expense']
            });
        }
    };
}

export function changeExpenseStatus(status,expenseId,successCallBack) {
    return async (dispatch) => {
        const response = await API.changeExpenseStatus(status);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch(getExpenseDetails(expenseId));
            successCallBack(response.data);
        }
    };
}


export function changeExpenseEstimateStatus(formData,estimateId,successCallBack) {
    return async (dispatch) => {
        const response = await API.changeExpenseEstimateStatus(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch(getEstimateDetails(estimateId));
            successCallBack(response.data);
        }
    };
}



export function updateExpenseEstimate(formData,successCallBack, estimateId,inspectionId) {
    return async (dispatch) => {
        const response = await API.updateExpenseEstimate(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        if(estimateId){
            dispatch(getEstimateDetails(estimateId))
        }
        if(inspectionId){
            dispatch(getInspectionDetailById(inspectionId))
        }
    };
}


export function deleteExpenseEstimate(adjustmentId, successCallBack, estimateId){
    return async (dispatch) => {
        const response = await API.deleteExpense(adjustmentId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        if(estimateId){
            dispatch(getEstimateDetails(estimateId))
        }
    }
}


export function createExpense(formData,inspectionId,successCallBack){
    return async(dispatch) => {
        const response = await API.createExpense(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(response){
                successCallBack(response.data);
            }
            if(response.data.success){
                dispatch(getInspectionDetailById(inspectionId))
            }
        }
    }
}

export function approveSelectedExpenses(formData,successcallBack){
    return async(dispatch) => {
        const response = await API.approveSelectedExpenses(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(successcallBack){
                successcallBack(response.data);
            }
            if(response.data.success){
                dispatch(getExpenseEstimates());
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/account_expense_action.js